import { Box, Container, Stack, Typography } from '@mui/material';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth, useRouter } from 'src/hooks';
import { A11yBtn } from '../a11y-btn';
import { AuthOneId } from '../auth';
import { LangSwitcher } from '../lang-switcher';
import { Logo } from '../logo';
import { UserMenu } from '../user-menu';
import useStyles from './styles';

export interface HeaderProps {
  title?: string;
  subtitle?: string;
  isHomepage?: boolean;
}
export const Header: ComponentType<HeaderProps> = ({ title, subtitle, isHomepage }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const router: any = useRouter();
  const { isAuthorized, handleAuthViaCode } = useAuth();

  useEffect(() => {
    if (router?.query?.code) {
      handleAuthViaCode(router?.query?.code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={classes.root} mb={7.5}>
      <Container sx={{ maxWidth: 1200, py: 0, px: 3.75 }}>
        <Stack
          direction="row"
          py={1.5}
          alignItems="center"
          spacing={5}
          justifyContent={'space-between'}
        >
          <Box display={'flex'} alignItems={'center'} width={'100%'} ml={'auto'} gap={5}>
            <Logo sx={{ fontSize: 48, mr: 'auto' }} />
            {/* <Link href={'instruction'} sx={{ textDecoration: 'none', color: '#fff' }}>
                {t('instruction.title')}
              </Link> */}
            <A11yBtn />
            <LangSwitcher variant="white" />
            {isAuthorized && <UserMenu variant="light" />}
          </Box>
        </Stack>
        {(isHomepage && (
          <Box textAlign="center" pt={2} pb={5}>
            <Typography
              variant="h1"
              mb={5}
              dangerouslySetInnerHTML={{
                __html: t(
                  'fullProjectName',
                  `Единая информационная система аттестации <br />выдачи сертификатов медицинским и фармацевтическим работникам <br />о присвоении квалификационной категориив`
                ),
              }}
            />
            <Stack direction="row" spacing={3} justifyContent="center">
              <AuthOneId />
            </Stack>
          </Box>
        )) || (
          <Stack textAlign="center" pt={4} pb={11.75} spacing={2}>
            {title && <Typography variant="h1">{title}</Typography>}
            {subtitle && <Typography variant="body1">{subtitle}</Typography>}
          </Stack>
        )}
      </Container>
    </Box>
  );
};
